'use client';

import { useModals } from '@/contexts/ModalContext';
import { GeneralSettingsModal } from '@/modals/GeneralSettingsModal';
import { useLocale, useTranslations } from 'next-intl';
import Image from 'next/image';
import { useCallback } from 'react';
import { Button } from '@/components/ui/button';
import { appLocales, getLocaleConfig, isSupportedLocale } from '@/i18n/locales';

export const GeneralSettingsSwitchClient = () => {
  const modals = useModals();
  const t = useTranslations();
  const altT = useTranslations('alts');
  const locale = useLocale();
  const activeLocale = isSupportedLocale(locale) ? locale : appLocales[0];
  const onClickSwitch = useCallback(() => {
    modals.open(
      'general-settings',
      <GeneralSettingsModal
        onOk={async () => {
          modals.close('general-settings');
        }}
      />,
      true,
      'md:h-unset h-unset absolute md:static bottom-0 rounded-b-none md:rounded-b-[24px] m-0 max-h-full!',
    );
  }, [modals]);

  return (
    <Button
      variant='ghost'
      dir='ltr'
      title={altT('globe')}
      onClick={onClickSwitch}
      className='h-[32px] w-auto gap-[6px] p-0 hover:bg-transparent'
    >
      <Image alt={altT('globe')} src='/assets/icons/globe.svg' width={24} height={24} />
      <span className='hidden md:inline text-[14px] font-medium text-text-primary-day'>
        {t(getLocaleConfig(activeLocale).headerShortKey)}
      </span>
    </Button>
  );
};
